<template>
<div class="page-wrapper">
    <div class="container-fluid">

        <div class="page-header d-print-none">
            <div class="container-xl">
                <div class="row align-items-center">
                    <div class="col">
                        <h2 class="page-title">
                            Credits
                        </h2>
                    </div>
                </div>
            </div>
        </div>

        <div class="page-body">
            <div class="container-xl">

                <div class="row row-cards">
                    <div class="col-12">
                        <div class="card card-sm">
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col-auto">
                                        <span class="bg-primary text-white avatar">
                                            <icon icon="receipt-long" height="24" />
                                        </span>
                                    </div>
                                    <div class="col">
                                        <div class="text-secondary">
                                            Remaining AI avatar video credit
                                        </div>
                                        <div class="font-bold">
                                            {{ creditMinutes }} minutes
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col-auto">
                                        <span class="bg-secondary text-white avatar">
                                            <icon icon="credit-card-gear" height="24" />
                                        </span>
                                    </div>
                                    <div class="col">
                                        <div class="text-secondary">
                                            Used AI avatar video credit
                                        </div>
                                        <div class="font-bold">
                                            {{ creditUsageMinutes }} minutes
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-xl-3" v-for="(price) in prices" :key="price.id">
                        <div class="card card-md">
                            <div class="ribbon ribbon-top ribbon-bookmark bg-green" v-if="price.highlight">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-filled"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path></svg>
                            </div>
                            <div class="card-body text-center">
                                <div v-if="price.highlight" class="most-popular">Most popular</div>
                                <div class="display-6 fw-bold my-3">{{price.price}}</div>
                                <div class="font-weight-medium">{{price.title}}</div>
                                <div class="text-center mt-4">
                                    <a @click.prevent="loadCustomerDetails(price)" href="#" :class="!price.highlight ? 'btn w-100' : 'btn btn-green w-100'">Buy Credit</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <button class="btn btn-outline" @click="billingPortal">
                            Billing portal
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <modal ref="information">
        <form @submit.prevent="save">
            <div class="modal-body">
                <label class="row mb-3">
                    <span class="col-md-3">Account Type</span>
                    <div class="col">
                        <div class="btn-group">
                            <button type="button" class="btn" :class="{'btn-outline': information.type === 'commercial', 'btn-primary': information.type !== 'commercial'}" @click="information.type = 'personal'">Personal</button>
                            <button type="button" class="btn" :class="{'btn-outline': information.type === 'personal', 'btn-primary': information.type !== 'personal'}" @click="information.type = 'commercial'">Commercial</button>
                        </div>
                    </div>
                </label>
                <label class="row mb-3">
                    <label class="col-md-3" v-if="information.type === 'commercial'">Company name</label>
                    <label class="col-md-3" v-if="information.type === 'personal'">Name</label>
                    <div class="col">
                        <input class="form-control" type="text" v-model="information.name" required placeholder="" />
                    </div>
                </label>
                <div class="row mb-3">
                    <label class="col-md-3">E-mail</label>
                    <div class="col">
                        <input class="form-control" type="text" v-model="information.email" required placeholder="" />
                    </div>
                </div>
                <div class="row mb-3">
                    <label class="col-md-3">Country</label>
                    <div class="col">
                        <select class="form-control" v-model="information.country" required>
                            <option v-for="country in countries" :key="country.id" :value="country.alpha_2">{{country.title}}</option>
                        </select>
                    </div>
                </div>
                <div v-if="information.type === 'commercial'" class="row mb-3">
                    <label class="col-md-3">Address line 1</label>
                    <div class="col">
                        <input class="form-control" type="text" v-model="information.line1" required placeholder="" />
                    </div>
                </div>
                <div v-if="information.type === 'commercial'" class="row mb-3">
                    <label class="col-md-3">Address line 2</label>
                    <div class="col">
                        <input class="form-control" type="text" v-model="information.line2" required placeholder="" />
                    </div>
                </div>
                <div v-if="information.type === 'commercial'" class="row mb-3">
                    <label class="col-md-3">Postal code</label>
                    <div class="col">
                        <input class="form-control" type="text" v-model="information.postal_code" required placeholder="" />
                    </div>
                </div>
                <div v-if="information.type === 'commercial'" class="row mb-3">
                    <label class="col-md-3">City</label>
                    <div class="col">
                        <input class="form-control" type="text" v-model="information.city" required placeholder="" />
                    </div>
                </div>
                <div v-if="information.type === 'commercial' && hasState" class="row mb-3">
                    <label class="col-md-3">State</label>
                    <div class="col">
                        <input class="form-control" type="text" v-model="information.state" placeholder="" />
                    </div>
                </div>
                <div v-if="information.type === 'commercial'" class="row mb-3">
                    <label class="col-md-3">EU VAT no. <icon title="'(optional) Enter European VAT number if registered'" icon="info" :height="16" style="display: inline-block;vertical-align: top "></icon></label>
                    <div class="col">
                        <input class="form-control" type="text" v-model="information.eu_vat_id" placeholder="" />
                    </div>
                </div>
                <div v-if="information.type === 'commercial'" class="row mb-3">
                    <label class="col-md-3">Company number</label>
                    <div class="col">
                        <input class="form-control" type="text" v-model="information.company_number" required placeholder="" />
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" :disabled="loading">Save</button>
            </div>
        </form>
    </modal>
</div>

</template>

<script>
import api from "@/common/api";

import { mapState } from "vuex";

export default {
    computed: {
        ...mapState(["auth", "credit"]),

        creditMinutes() {
            return (Math.floor(this.credit.remaining) / 60).toFixed(2);
        },
        creditUsageMinutes() {
            return (Math.ceil(this.credit.duration) / 60).toFixed(2);
        },

        hasState() {
            const country = this.countries.find(c => c.alpha_2 === this.information.country);
            return country && !!country.states;
        }
    },
    components: {
    },
    data() {
        return {
            loading: false,
            prices: [],
            information: {
                type: "commercial",
                name: null,
                country: null,
                city: null,
                company_number: null,
                email: null,
                eu_vat_id: null,
                line1: null,
                line2: null,
                postal_code: null,
                state: null
            },
            selectedPrice: null,
            countries: []
        };
    },
    created() {
        this.load();
    },
    methods: {
        billingPortal() {
            api.billingPortal().then(data => {
                window.location = data.url;
            }).catch(e => {
                this.flashError(e);
            });
        },
        loadCustomerDetails(price) {
            this.selectedPrice = price;
            api.billingCountries().then(data => {
                this.countries = data;

                api.billingInformation({}).then(info => {
                    this.information = info;
                    this.$refs.information.open();
                }).catch(e => {
                    this.flashError(e);
                });
            }).catch(e => {
                this.flashError(e);
            });
        },
        save() {
            api.billingInformation(this.information).then(data => {
                api.billingPaymentLink(this.selectedPrice.id).then(data => {
                    window.location = data.url;
                }).catch(e => {
                    this.flashError(e);
                });
            }).catch(e => {
                this.flashError(e);
            });
        },
        load() {
            this.$store.dispatch("credit/update");

            api.billingPortalPackages().then(data => {
                this.prices = data;
            }).catch(e => {
                this.flashError(e);
            });
        }
    }
};
</script>

<style scoped>
.most-popular {
    position: absolute;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #2fb344;
}
</style>
